import React, { useEffect, useRef, useState } from 'react';
import { useCookies } from 'react-cookie';
import ReactDOM from 'react-dom/client';
import { COOKIE_SETTINGS, CookiePreferencesModal } from 'venn-components';
import { analyticsService } from 'venn-utils';

const HUBSPOT_FOOTER_CLASS_SELECTOR = '.custom-privacy ul li';
const LIST_ITEM_CLASS_SELECTOR = `${HUBSPOT_FOOTER_CLASS_SELECTOR}.cookie-preferences`;
/* Provides a self-mounting launch point for the cookie preferences modal in the Marketing Website Footer */
const CookiePreferencesLaunchPoint = () => {
  const [cookies] = useCookies([COOKIE_SETTINGS]);
  const [showModal, setShowModal] = useState(false);
  const listItemAdded = useRef(false);

  const openModal = () => {
    setShowModal(true);
    analyticsService.ctaClicked({
      locationOnPage: 'footer',
      purpose: 'Open Cookie Preferences Manager',
      text: 'Cookie Preferences Manager',
      type: 'link',
    });
  };

  const closeModal = () => {
    setShowModal(false);
  };

  useEffect(() => {
    // If the user has set their cookie settings, insert a link to the modal in the footer
    if (cookies[COOKIE_SETTINGS]) {
      // Dynamically add a target element to render the cookie preferences modal trigger point
      if (!listItemAdded.current) {
        const newLi = document.createElement('li');
        newLi.className = 'cookie-preferences';
        const lis = document.querySelectorAll(HUBSPOT_FOOTER_CLASS_SELECTOR);
        const lastLi = lis[lis.length - 1];
        lastLi?.parentNode?.insertBefore(newLi, null);
        listItemAdded.current = true;
      }
      const CookieLink = (
        <li>
          {/* eslint-disable-next-line */}
          <a tabIndex={0} onClick={openModal}>
            Do Not Share My Personal Information
          </a>
        </li>
      );

      const container = document.querySelector(LIST_ITEM_CLASS_SELECTOR);
      if (container) {
        // don't render if we can't find the list item
        const root = ReactDOM.createRoot(container);
        root.render(CookieLink);
      }
    }
  }, [cookies]);

  if (showModal) {
    return (
      <CookiePreferencesModal originalCookiePreferences={parseInt(cookies[COOKIE_SETTINGS], 10)} onClose={closeModal} />
    );
  }
  return null;
};

export default CookiePreferencesLaunchPoint;
